import { gql } from "@apollo/client";export default gql`mutation IncrementCollectionDuration($duration: Int!, $id: Int!) {
    update_collection_by_pk(
        pk_columns: { id: $id }
        _inc: { duration: $duration }
    ) {
        id
    }
}
`;
